export default "__VITE_ASSET__DUFLgI31__";